import React from 'react'
let PropTypes = React.PropTypes

import Modal from 'react-bootstrap/lib/Modal.js'

import classNames from 'classnames/bind'
import * as css from './Modales.css'
let cx = classNames.bind(css)

export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = {visible: false}
        let self = this
        this.show = ()=>
            self.setState({visible: true})
        this.hide = ()=>{
            self.setState({visible: false})
        }
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class ModalHospedaje extends React.Component{
    constructor(props){
        super(props)
        this.buscarComuna = this.buscarComuna.bind(this)
        this.state = {
            hospedaje: [],
            comunas:[],
            error: []
        }
        this.onInputChange=(key, evt)=>{
            let actualizado = {}
            if(key === 'idComuna'){
                actualizado[key] = this.buscarComuna(evt.target.value)
                actualizado.nombreComuna = evt.target.value
            }else{
                actualizado[key] = evt.target.value
            }
            actualizado['editado'] = 1
            this.setState({ hospedaje: Object.assign({}, this.state.hospedaje, actualizado)})
        }
        this.guardarHospedaje=()=>{
            this.context.guardaHospedaje(this.state.hospedaje)
                .then(hospedaje=>{
                    this.setState({
                        hospedaje,
                        error: []
                    },()=>this.props.hideModal())
                })
                .catch(err=>{
                    console.log(err)
                    this.setState({
                        error: err.data
                    })
                })
        }
    }
    buscarComuna(nombre){
        for (var i=0; i < this.state.comunas.length; i++) {
            if (this.state.comunas[i].nombre === nombre) {
                return this.state.comunas[i].cutComuna;
            }
        }
    }
    componentWillMount(){
        this.context.getComunas()
            .then(comunas=>{
                this.setState({
                    comunas,
                    hospedaje: !this.props.nuevo? this.props.hospedaje : []
                })
            })
            .catch(err=>{
                console.log(err)
            })
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalHospedaje')} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>Hospedaje</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel panel-info">
                                <div className="panel-body">
                                    <div className={cx('col-md-4 form-group', 'form__control-label')}>
                                        <label className="col-md-4">Nombre</label>
                                        <div className="col-md-8">
                                            <input type="text" className="form-control" placeholder="Nombre"
                                                value={this.state.hospedaje.nombre} onChange={this.onInputChange.bind(this, 'nombre')}
                                            />
                                            {this.state.error.nombre && <span className={cx('form__error-message')}>{this.state.error.nombre}</span>}
                                        </div>
                                    </div>
                                    <div className={cx('col-md-4 form-group', 'form__control-label')}>
                                        <label className="col-md-4 control-label">Comuna</label>
                                        <div className="col-md-8">
                                            <input type="text" list="comunas" placeholder="Comuna"
                                                className="form-control"
                                                value={this.state.hospedaje.nombreComuna}
                                                onChange={this.onInputChange.bind(this, 'idComuna')}/>
                                            <datalist id="comunas">
                                                {this.state.comunas.map((comuna, index)=>{
                                                    return <option key={comuna.cutComuna} value={comuna.nombre}/>
                                                })}
                                            </datalist>
                                            {this.state.error.idComuna && <span className={cx('form__error-message')}>{this.state.error.idComuna}</span>}
                                        </div>
                                    </div>
                                    <div className={cx('col-md-4 form-group', 'form__control-label')}>
                                        <label className="col-md-4 control-label">Prioridad</label>
                                        <div className="col-md-8">
                                            <input type="number" className="form-control" placeholder="Prioridad"
                                                value={this.state.hospedaje.prioridad} onChange={this.onInputChange.bind(this, 'prioridad')}
                                            />
                                            {this.state.error.prioridad && <span className={cx('form__error-message')}>{this.state.error.prioridad}</span>}
                                        </div>
                                    </div>
                                    <div className={cx('col-md-4 form-group', 'form__control-label')}>
                                        <label className="col-md-4 control-label">Tel. Fijo</label>
                                        <div className="col-md-8">
                                            <input type="number" className="form-control" placeholder="Teléfono Fijo"
                                                value={this.state.hospedaje.telefono_fijo} onChange={this.onInputChange.bind(this, 'telefono_fijo')}
                                            />
                                            {this.state.error.telefono_fijo && <span className={cx('form__error-message')}>{this.state.error.telefono_fijo}</span>}
                                        </div>
                                    </div>
                                    <div className={cx('col-md-4 form-group', 'form__control-label')}>
                                        <label className="col-md-4 control-label">Celular</label>
                                        <div className="col-md-8">
                                            <input type="number" className="form-control" placeholder="Celular" defaultValue="569"
                                                value={this.state.hospedaje.celular} onChange={this.onInputChange.bind(this, 'celular')}
                                            />
                                            {this.state.error.celular && <span className={cx('form__error-message')}>{this.state.error.celular}</span>}
                                        </div>
                                    </div>
                                    <div className={cx('col-md-4 form-group', 'form__control-label')}>
                                        <label className="col-md-4 control-label">Whatsapp</label>
                                        <div className="col-md-8">
                                            <input type="number" className="form-control" placeholder="Whatsapp" defaultValue="569"
                                                value={this.state.hospedaje.celular_wsp} onChange={this.onInputChange.bind(this, 'celular_wsp')}
                                            />
                                            {this.state.error.celular_wsp && <span className={cx('form__error-message')}>{this.state.error.celular_wsp}</span>}
                                        </div>
                                    </div>
                                    <div className={cx('col-md-6 form-group', 'form__control-label')}>
                                        <label className="col-md-4 control-label">Email Principal</label>
                                        <div className="col-md-8">
                                            <input type="text" className="form-control" placeholder="Email Principal"
                                                value={this.state.hospedaje.mail_principal} onChange={this.onInputChange.bind(this, 'mail_principal')}
                                            />
                                            {this.state.error.mail_principal && <span className={cx('form__error-message')}>{this.state.error.mail_principal}</span>}
                                        </div>
                                    </div>
                                    <div className={cx('col-md-6 form-group', 'form__control-label')}>
                                        <label className="col-md-4 control-label">Email Secundario</label>
                                        <div className="col-md-8">
                                            <input type="text" className="form-control" placeholder="Email Secundario"
                                                value={this.state.hospedaje.mail_secundario} onChange={this.onInputChange.bind(this, 'mail_secundario')}
                                            />
                                            {this.state.error.mail_secundario && <span className={cx('form__error-message')}>{this.state.error.mail_secundario}</span>}
                                        </div>
                                    </div>
                                    <div className={cx('col-md-7 form-group', 'form__control-label')}>
                                        <label className="col-md-2 control-label">Dirección</label>
                                        <div className="col-md-10">
                                            <input type="text" className="form-control" placeholder="Dirección"
                                                value={this.state.hospedaje.direccion} onChange={this.onInputChange.bind(this, 'direccion')}
                                            />
                                            {this.state.error.direccion && <span className={cx('form__error-message')}>{this.state.error.direccion}</span>}
                                        </div>
                                    </div>
                                    <div className={cx('col-md-5 form-group', 'form__control-label')}>
                                        <label className="col-md-4 control-label">GeoReferencia</label>
                                        <div className="col-md-8">
                                            <input type="text" className="form-control" placeholder="GeoReferencia" disabled
                                                value={this.state.hospedaje.georeferencia} onChange={this.onInputChange.bind(this, 'georeferencia')}
                                            />
                                            {this.state.error.georeferencia && <span className={cx('form__error-message')}>{this.state.error.georeferencia}</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-info">
                                <div className="panel-heading">Habitaciones</div>
                                <div className="panel-body">
                                    <div className={cx('col-md-4 form-group', 'form__control-label')}>
                                        <label className="col-md-4 control-label">Single</label>
                                        <div className="col-md-8">
                                            <input type="number" className="form-control" placeholder="Single"
                                                value={this.state.hospedaje.single_con_bano} onChange={this.onInputChange.bind(this, 'single_con_bano')}
                                            />
                                            {this.state.error.single_con_bano && <span className={cx('form__error-message')}>{this.state.error.single_con_bano}</span>}
                                        </div>
                                    </div>
                                    <div className={cx('col-md-4 form-group', 'form__control-label')}>
                                        <label className="col-md-4 control-label">Doble</label>
                                        <div className="col-md-8">
                                            <input type="number" className="form-control" placeholder="Doble"
                                                value={this.state.hospedaje.doble_con_bano} onChange={this.onInputChange.bind(this, 'doble_con_bano')}
                                            />
                                            {this.state.error.doble_con_bano && <span className={cx('form__error-message')}>{this.state.error.doble_con_bano}</span>}
                                        </div>
                                    </div>
                                    <div className={cx('col-md-4 form-group', 'form__control-label')}>
                                        <label className="col-md-4 control-label">Cuádruple</label>
                                        <div className="col-md-8">
                                            <input type="number" className="form-control" placeholder="Cuádruple"
                                                value={this.state.hospedaje.cuadruple_con_bano} onChange={this.onInputChange.bind(this, 'cuadruple_con_bano')}
                                            />
                                            {this.state.error.cuadruple_con_bano && <span className={cx('form__error-message')}>{this.state.error.cuadruple_con_bano}</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-2 pull-left">
                        <button className="btn btn-md btn-primary" onClick={this.guardarHospedaje}>Guardar</button>
                    </div>
                    <div className="col-md-6 pull-right">
                        <button className="btn btn-md btn-cancel" onClick={this.props.hideModal}>Cancelar</button>
                    </div>
                </Modal.Footer>
            </Modal>

        )
    }
}
ModalHospedaje.contextTypes = {
    guardaHospedaje: PropTypes.func,
    getComunas: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/proveedores/hospedajes/Modales.jsx